import React from "react";
import style from "css/admin/component.module.css";
import { Modal, Button, ConfigProvider } from "antd";

function MemberDeleteConfirmModal({
  open,
  onCancel,
  onConfirm,
  loading = false,
  records = [],
}) {
  const count = records.length;
  const displayList =
    count <= 3
      ? records
          .map((r) =>
            [r.MEMBER_ID, r.MEMBER_NM].filter(Boolean).join(" / ")
          )
          .join(", ")
      : records
          .slice(0, 3)
          .map((r) =>
            [r.MEMBER_ID, r.MEMBER_NM].filter(Boolean).join(" / ")
          )
          .join(", ") + ` 외 ${count - 3}명`;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      closable={false}
      maskClosable={!loading}
      styles={{
        content: { borderRadius: 12 },
        mask: { backdropFilter: "none" },
      }}
      footer={
        <ConfigProvider
          theme={{
            token: { colorPrimary: "#f65c22" },
            components: {
              Button: {
                colorPrimaryHover: "#e4561f",
                colorPrimaryActive: "#cc4b1b",
              },
            },
          }}
        >
          <div className={style.modal_footer_wrap}>
            <Button
              key="cancel"
              onClick={onCancel}
              disabled={loading}
              className={style.modal_footer_btn}
            >
              취소
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={onConfirm}
              loading={loading}
              className={style.modal_footer_btn}
            >
              삭제
            </Button>
          </div>
        </ConfigProvider>
      }
      centered
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          paddingTop: 6,
        }}
      >
        <div
          className={style.searchItem_label}
          style={{ fontSize: 16, textAlign: "center" }}
        >
          {displayList || "-"}
        </div>
        <div
          className={style.searchItem_label}
          style={{ fontSize: 15, fontWeight: 500, textAlign: "center" }}
        >
          선택한 사용자 {count}명을 삭제하시겠습니까?
        </div>
      </div>
    </Modal>
  );
}

export default MemberDeleteConfirmModal;
